<template>
  <div>
    <div class="usage-bar">
      <!-- Filled part -->
      <div
        class="used"
        :style="{
          'background-color': usageColor,
          width: usageWidth
        }"
      ></div>
      <div class="percentage-field">
        <!-- Usage bar percentage text -->
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
// @group Admin Page
// Colored usage bar
export default {
  name: "UsageBar",
  props: {
    // Usage part in range [0, 1]
    usage: {
      type: Number,
      default: 0,
      validator: val => {
        return val >= 0 && val <= 1;
      }
    }
  },
  data() {
    return {
      // Alpha channel of bar used color
      colorIntensity: 0.7
    };
  },
  computed: {
    // @vuese
    // Color of used part that changes from green to red while usage increasing
    usageColor() {
      let green = 0;
      let red = 0;
      if (this.usage < 0.5) {
        /** green is max, red is raising from 0 to 255 */
        green = 255;
        red = this.usage * 510;
      } else {
        /** red is max, green is decreasing from 0 to 255 */
        green = (1 - this.usage) * 510;
        red = 255;
      }

      return `rgba(${red}, ${green}, 0, ${this.colorIntensity})`;
    },
    // @vuese
    // Width of used color in percentage
    usageWidth() {
      const width = this.usage * 100 + "%";
      return width;
    }
  }
};
</script>

<style scoped>
.usage-bar {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: var(--sidebar-bg-color);
  border-radius: 5px;

  display: flex;
  justify-content: center;
  align-items: center;
}

.used {
  position: absolute;
  left: 0;
  height: 100%;
  border-radius: 5px 0 0 5px;
  transition: width var(--long-transition),
    background-color var(--long-transition);
}

.percentage-field {
  opacity: 0;
  z-index: var(--first-layer);
  transition: opacity var(--fast-transition);
}

.usage-bar:hover .percentage-field {
  opacity: 1;
}
</style>
